module.exports = __webpack_public_path__ + "img/1504x470.df5df01a.jpg";